import React from "react";

import { Control } from "react-hook-form";

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from "~/components/ui/form";
import { AddressFormValues } from "~/pages/clients/components/client-detail/address/form/AddressForm";

interface DefaultAddressCheckboxProps {
  control: Control<AddressFormValues>;
}

const DefaultAddressCheckbox: React.FC<DefaultAddressCheckboxProps> = ({
  control,
}) => {
  return (
    <FormField
      control={control}
      name="isDefault"
      render={({ field }) => (
        <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
          <FormControl>
            <input
              type="checkbox"
              checked={field.value}
              onChange={field.onChange}
              className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
            />
          </FormControl>
          <div className="space-y-1 leading-none">
            <FormLabel>Establecer como dirección principal</FormLabel>
            <FormDescription>
              Esta dirección será utilizada como predeterminada para las
              entregas.
            </FormDescription>
          </div>
        </FormItem>
      )}
    />
  );
};

export default DefaultAddressCheckbox;
